import React from "react";
import footbal from "../../../assets/customerAssets/football.png";
import { Button, Box, Typography, CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { fetchUserGoalData } from "../../../action/userGoals";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import CachedIcon from "@mui/icons-material/Cached";
import GuestUserRistModal from "../../Modals/user/guestUserModalRist/Modal";

const Options = () => {
  const [featuredLinks, setFeaturedLinks] = useState([]);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();
  const loggedUser = useSelector((state) => state.loggedUser.user);

  const [openGuestRistModal, setOpenGuestRistModal] = React.useState(false);

  const features = useSelector((state) => state.features);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL_USER}/featured-link`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const { success, data } = response?.data;
        if (success) {
          setFeaturedLinks(data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchLinks();
  }, []);

  console.log(loggedUser, "jslfjalkfjdlkafjl logged user ");

  return (
    <>
      <Box className="home-options-wrapper">
        {/* <Container> */}
        <Box className="home-options-inner">
          <div className="option-outter-wrapper">
            <Button
              className="option-outter"
              sx={{ padding: "0" }}
              onClick={() => {
                if (loggedUser.device_id) {
                  // navigate("/login");
                  setOpenGuestRistModal(true);
                  return;
                } else {
                  navigate("/addGoal");
                }
              }}
            >
              <div
                className="option-inner"
                style={{ backgroundColor: "#ffcd1f", color: "white" }}
              >
                +
              </div>
            </Button>
            <Typography component="span">Add Goal</Typography>
          </div>
          <div className="option-outter-wrapper">
            <Button
              className="option-outter"
              sx={{ padding: "0" }}
              onClick={() => {
                dispatch({ type: "USER_GOALS_REFRESH" });

                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <div className="option-inner">
                <CachedIcon
                  sx={{ fontSize: "31px", transform: "rotate(20deg)" }}
                />
              </div>
            </Button>
            <Typography component="span" sx={{ wordBreak: "break-all" }}>
              Refresh
            </Typography>
          </div>

          <div className="option-outter-wrapper">
            <Button
              className="option-outter"
              sx={{ padding: "0" }}
              onClick={() => {
                if (loggedUser.device_id) {
                  setOpenGuestRistModal(true);
                  return;
                  // navigate("/login");
                } else {
                  navigate("/addGoal?from=Youth_Football");
                }
              }}
            >
              <div className="option-inner">
                <img
                  src={footbal}
                  alt="football"
                  className="img_fluid"
                  style={{ opacity: "24%" }}
                />
              </div>
            </Button>
            <Typography component="span" sx={{ wordBreak: "break-all" }}>
              Youth Football
            </Typography>
          </div>

          {features.loading ? (
            <CircularProgress sx={{ color: "#ef364e" }} />
          ) : features.data?.data?.length > 0 ? (
            features.data.data
              ?.filter((fetu) => fetu.enable)
              .map((item, index) => (
                <div className="option-outter-wrapper">
                  <Button
                    className="option-outter"
                    sx={{ padding: "0" }}
                    onClick={() => {
                      if (loggedUser.device_id) {
                        setOpenGuestRistModal(true);
                        return;
                      }

                      switch (item.id) {
                        case 1:
                          navigate("/addChallenge");
                          break;
                        case 2:
                          navigate("/addTournament");
                          break;
                        case 3:
                          navigate("/addClub");
                          break;
                        case 4:
                          navigate("/addLeague");
                          break;
                        case 5:
                          window.open(
                            "https://www.youtube.com/watch?v=OsOx-q5Z6qw",
                            "_blank"
                          );
                          break;
                        default:
                          break;
                      }
                    }}
                  >
                    <div className="option-inner">
                      <img
                        src={footbal}
                        alt="football"
                        className="img_fluid"
                        style={{ opacity: "24%" }}
                      />
                    </div>
                  </Button>
                  <Typography
                    component="span"
                    sx={item.id == 2 ? { wordBreak: "break-all" } : {}}
                  >
                    {item.name}
                  </Typography>
                </div>
              ))
          ) : null}

          {/* <div className="option-outter-wrapper">
            <Button
              className="option-outter"
              sx={{ padding: "0" }}
              onClick={() => {
                window.open("https://www.youtube.com/watch?v=OsOx-q5Z6qw");
              }}
            >
              <div className="option-inner">
                <img
                  src={footbal}
                  alt="football"
                  className="img_fluid"
                  style={{ opacity: "24%" }}
                />
              </div>
            </Button>
            <Typography component="span">FanZone</Typography>
          </div> */}
          <div className="option-outter-wrapper">
            <Button sx={{}}></Button>
          </div>
        </Box>
        {/* </Container> */}
      </Box>

      <GuestUserRistModal
        open={openGuestRistModal}
        setOpen={setOpenGuestRistModal}
      />
    </>
  );
};

export default Options;
